<template>
    <div v-if="!loading" class="finance-quote__notification-area">
        <p v-for="(message, index) in errorMessages" :key="index" class="bg-warning validation-error">
            <svg class="animated shake" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65"><path d="M32.5 0C14.6 0 0 14.6 0 32.5S14.6 65 32.5 65 65 50.4 65 32.5 50.4 0 32.5 0zM32.5 61C16.8 61 4 48.2 4 32.5S16.8 4 32.5 4 61 16.8 61 32.5 48.2 61 32.5 61z"></path><circle cx="33" cy="19.5" r="3.3"></circle><path d="M32.1 28.3c-1.1 0-2 0.9-2 2v17c0 1.1 0.9 2 2 2s2-0.9 2-2v-17C34.1 29.2 33.2 28.3 32.1 28.3z"></path></svg>
            <span v-html="message"></span>
        </p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import numberFormat from '../../api/NumberFormat';

export default {
    props: {
        loading: {
            required: true,
        },
        quote: {
            required: true,
        },
        term: {
            required: true,
        },
        termChanged: {
            required: true,
        },
        deposit: {
            required: true,
        },
        mileage: {
            required: true,
        },
        mileageChanged: {
            required: true,
        },
    },
    computed: {
        errorMessages() {
            if (typeof this.quote.Quote == 'undefined') {
                return [];
            }
            let errorMessages = [];
            if (this.mileageChanged !== false) {
                errorMessages.push('The mileage you chose ('+numberFormat(this.mileageChanged,0)+' miles per annum) was unavailable, the nearest alternative of '+numberFormat(this.quote.Quote.AnnualMileage,0)+' has been used instead');
            }
            else if (typeof this.mileage !== 'undefined' && typeof this.quote.Quote.AnnualMileage !== 'undefined' && parseInt(this.quote.Quote.AnnualMileage) > 0 && parseInt(this.quote.Quote.AnnualMileage) != parseInt(this.mileage)) {
                errorMessages.push('<span class="glyphicons glyphicons-exclamation-sign pull-left animated pulse"></span>The mileage you chose ('+numberFormat(this.mileage,0)+' miles per annum) was unavailable, the nearest alternative of '+numberFormat(this.quote.Quote.AnnualMileage,0)+' has been used instead');
            }

            if (typeof this.deposit !== 'undefined' && typeof this.quote.Quote.CashDeposit !== 'undefined'  && parseInt(this.quote.Quote.CashDeposit) != parseInt(this.deposit) && Math.abs(parseFloat(this.quote.Quote.CashDeposit) - parseFloat(this.deposit)) > 3 ) {
                errorMessages.push('<span class="glyphicons glyphicons-exclamation-sign pull-left animated pulse"></span>The deposit you chose (&pound;'+numberFormat(this.deposit,2)+') was unavailable, the nearest alternative of &pound;'+numberFormat(this.quote.Quote.CashDeposit,2)+' has been used instead');
            }

            if (this.termChanged !== false) {
                errorMessages.push('<span class="glyphicons glyphicons-exclamation-sign pull-left animated pulse"></span>The term you chose ('+numberFormat(this.termChanged,0)+' months) was unavailable, the nearest alternative of '+numberFormat(this.quote.Quote.Term,0)+' months has been used instead');
            }
            else if (typeof this.term !== 'undefined' && typeof this.quote.Quote.Term !== 'undefined'  && parseInt(this.quote.Quote.Term) != parseInt(this.term)) {
                errorMessages.push('<span class="glyphicons glyphicons-exclamation-sign pull-left animated pulse"></span>The term you chose ('+numberFormat(this.term,0)+' months) was unavailable, the nearest alternative of '+numberFormat(this.quote.Quote.Term,0)+' months has been used instead');
            }
            return errorMessages;
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Finance/FinanceAdjustmentNotifications.vue